export default "__VITE_ASSET__09cd652c__"